import { render, staticRenderFns } from "./BookedItem.vue?vue&type=template&id=3190e8c4&lang=pug&"
import script from "./BookedItem.vue?vue&type=script&lang=js&"
export * from "./BookedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports